import { Ref } from '@/decorators/ref';
import { assignOwnProperties } from '@/utils/assignOwnProperties';
import { normalize } from '@/utils/normalize';
import type { IResponseProfile } from '~/api/IResponseProfile';
import type { IStatusTimeInfo } from '~/api/IStatusTimeInfo';

export class ResponseProfile implements IResponseProfile {
  @Ref responseProfileId: number | string;
  @Ref responseProfileName: string;
  @Ref priorityInfo: Array<{ id: string; value: null | string }>;
  @Ref responseProfileStatusInfo: IStatusTimeInfo[];
  @Ref status: number;

  constructor(data: IResponseProfile) {
    assignOwnProperties(this, normalize(data));
  }
}
